export const REQUEST = 'userProduct/REQUEST';
export const FAILURE = 'userProduct/FAILURE';

export const UPLOAD_USER_PRODUCT_IMAGE_SUCCESS = 'userProduct/UPLOAD_USER_PRODUCT_IMAGE_SUCCESS';
export const SAVE_USER_PRODUCT_SUCCESS = 'userProduct/SAVE_USER_PRODUCT_SUCCESS';
export const GET_MY_USER_PRODUCTS_SUCCESS = 'userProduct/GET_MY_USER_PRODUCTS_SUCCESS';
export const DELETE_USER_PRODUCT_SUCCESS = 'userProduct/DELETE_USER_PRODUCT_SUCCESS';
export const CHANGE_PRICE_PRODUCT_SUCCESS = 'userProduct/CHANGE_PRICE_PRODUCT_SUCCESS';
